import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useFeatureName } from "@/hooks/use-pageTitle";
import PageContainer from "@/pages/containers/page-container";
import { CardContent } from "@/components/ui/card";

const NotificationItemSkeleton = () => {
  return (
    <Card className="">
      <CardContent className="m-4 flex size-full flex-col items-center justify-center gap-2">
        <Skeleton className="h-4 w-full bg-gray-200" />
        <Skeleton className="h-4 w-full bg-gray-200" />
        <Skeleton className="h-4 w-full bg-gray-200" />
      </CardContent>
    </Card>
  );
};

const NotificationSkeleton = () => {
  return (
    <PageContainer title={useFeatureName()}>
      <div className="m-4 flex flex-col gap-4">
        <NotificationItemSkeleton />
        <NotificationItemSkeleton />
        <NotificationItemSkeleton />
        <NotificationItemSkeleton />
        <NotificationItemSkeleton />
        <NotificationItemSkeleton />
      </div>
    </PageContainer>
  );
};

export default NotificationSkeleton;
